<template>
    <div class="content-section">
        <div class="content-section-heading">
            {{ this.trans('emails.index.assignment_mail') }}
        </div>
        <div class="content-row">
            <alert type="info">
                {{ infoText }}
            </alert>
        </div>
        <div class="content-row">
            <a class="" :href="url">
                <button
                    class="btn btn--big btn--primary"
                    v-text="text"
                ></button>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['client'],

    data() {
        return {
            show: !!this.client.specific_assignment_mail,
        };
    },

    computed: {
        url() {
            return this.show
                ? this.route('tenant.clients.emails.show', {
                      client: this.client.id,
                      email: 'assignment',
                  })
                : this.route('tenant.clients.emails.create', {
                      client: this.client.id,
                      email: 'assignment',
                  });
        },

        text() {
            return this.show
                ? this.trans('emails.button.assignment_mail.edit')
                : this.trans('emails.button.assignment_mail.create');
        },

        infoText() {
            return this.show
                ? this.trans('emails.label.specific_template')
                : this.trans('emails.label.no_specific_template');
        },
    },
};
</script>
